















































































/* eslint-disable @typescript-eslint/no-explicit-any */
import CtrlDatePicker from '@/components/common/control/CtrlDatePicker.vue';
import CtrlMessageDialog from '@/components/common/control/CtrlMessageDialog.vue';
import CtrlNormalBtn from '@/components/common/control/CtrlNormalBtn.vue';
import CtrlItakusaki from '@/components/common/search/CtrlItakusaki.vue';
import {
  OutStatus,
  ShiiresakiKb,
  UmuFlg,
  KaigaiKobetsuKb,
  Flg,
} from '@/constants/constants';
import { BUTTON } from '@/constants/label';
import { dateStrToNum } from '@/utils/utils';
import Vue from 'vue';
import { mapGetters } from 'vuex';

export default Vue.extend<any, any, any, any>({
  name: 'G_140_HaisoIrai_BatchOrderEditing',
  components: {
    CtrlNormalBtn,
    CtrlMessageDialog,
    CtrlDatePicker,
    CtrlItakusaki,
  },
  props: {
    show: {
      type: Boolean,
      default: false,
    },
    targetInfo: {
      type: Array,
      default: () => [],
    },
  },
  data: () => ({
    BUTTON,
    ShiiresakiKb,
    UmuFlg,
    Flg,
    KaigaiKobetsuKb,
    shukkaYoteiFlg: false,
    shukkaYoteiYmd: '',
    nohinYoteiFlg: false,
    nohinYoteiYmd: '',
    itakusakiFlg: false,
    itakusakiCd: 0,

    messageShow: false,
    messageId: '',
    messageTextParam: [],
    messageConfirm: false,
    isReload: false,
  }),
  computed: {
    ...mapGetters({
      userInfo: 'common/userInfo',
    }),
  },
  watch: {
    shukkaYoteiFlg() {
      this.shukkaYoteiYmd = '';
    },
    nohinYoteiFlg() {
      this.nohinYoteiYmd = '';
    },
    itakusakiFlg() {
      this.itakusakiCd = 0;
    },
  },
  methods: {
    hide(reload = true) {
      this.$emit('update:show', false);
      this.$emit('hide', reload);
    },
    handleCancelMessage() {
      this.messageConfirm = false;
    },
    handleOkMessage() {
      this.messageShow = false;
      this.messageId = '';
      this.messageTextParam = [];
      if (this.messageConfirm) {
        this.messageConfirm = false;
        this.handleSubmitUpdate();
        return;
      }
      if (this.isReload) {
        this.isReload = false;
        this.hide(true);
      }
    },
    callbackOkItakusaki(item: any) {
      if (item && item.itakusakiCd) {
        this.itakusakiCd = +item.itakusakiCd;
      } else {
        this.itakusakiCd = 0;
      }
    },
    async checkValidateUpdate() {
      await new Promise((resolve) => setTimeout(resolve, 300));
      this.$refs.form.validate();
      if (!this.shukkaYoteiFlg && !this.nohinYoteiFlg && !this.itakusakiFlg) {
        this.messageId = 'KI_W111';
        this.messageTextParam = ['一括更新項目未選択', '保存'];
        this.messageShow = true;
        return;
      }
      if (this.shukkaYoteiFlg && !this.shukkaYoteiYmd) {
        this.messageId = 'KI_W100';
        this.messageTextParam = ['出荷予定日'];
        this.messageShow = true;
        return;
      }
      if (this.nohinYoteiFlg && !this.nohinYoteiYmd) {
        this.messageId = 'KI_W100';
        this.messageTextParam = ['納品予定日'];
        this.messageShow = true;
        return;
      }
      if (!this.$refs.form.validate()) {
        this.messageId = 'KI_W121';
        this.messageTextParam = [];
        this.messageShow = true;
        return;
      }
      this.messageId = 'KI_Q101';
      this.messageTextParam = ['一括編集'];
      this.messageConfirm = true;
      this.messageShow = true;
    },
    async handleSubmitUpdate() {
      try {
        this.$store.dispatch('common/setIsLoading', true);
        const requestData = {
          commonInfo: {
            jigyoshoCd: this.userInfo.jigyoshoData.jigyoshoCd,
            genzaiYmd: this.userInfo.onlineData.genzaiYmd,
          },
          updateInfo: {
            shukkaYoteiYmd: this.shukkaYoteiFlg
              ? dateStrToNum(this.shukkaYoteiYmd)
              : -1,
            nohinYoteiYmd: this.nohinYoteiFlg
              ? dateStrToNum(this.nohinYoteiYmd)
              : -1,
            itakusakiCd: this.itakusakiFlg ? +this.itakusakiCd : -1,
          },
          targetInfo: this.targetInfo,
        };
        const res = await this.$store.dispatch('g140/putIkkatsu', requestData);
        this.$store.dispatch('common/setIsLoading', false);
        if (
          res &&
          res.status == 200 &&
          res.data &&
          res.data.error &&
          res.data.error.messageID &&
          res.data.error.outStatus &&
          res.data.error.outStatus != OutStatus.NORMAL
        ) {
          const { error } = res.data;
          if (error.outStatus == OutStatus.CHECK_ERR) {
            this.messageShow = true;
            this.messageId = error.messageID;
            this.messageTextParam = error.messageArgs;
            return;
          } else if (error.outStatus == OutStatus.EXCLUSIVE_ERR) {
            this.messageShow = true;
            this.messageId = error.messageID;
            this.messageTextParam = error.messageArgs;
            this.isReload = true;
            return;
          }
        }
        this.hide();
      } catch (error) {
        console.error(error);
      }
    },
  },
});
